import {
  AllUserAccountTypes,
  Artist,
  InputBooking,
} from '@beatgig/api-services'
import AnalyticsBase from './segment'

/**
 * Helpers...So ugly, I know 😬 Taken from nandorojo/gatsby-store
 *
 * this lets us change Server.post({ event: string, ... }) to Server.post(event, { ... }) dynamically
 *
 * See  https://artsy.github.io/blog/2018/11/21/conditional-types-in-typescript/ for explanation.
 */
type ExcludeEventKey<K> = K extends 'event' ? never : K
type ExcludeEventField<A> = { [K in ExcludeEventKey<keyof A>]: A[K] }
type ExtractEventParameters<A, T> = A extends { event: T }
  ? ExcludeEventField<A>
  : never

type ExcludeNameKey<K> = K extends 'name' ? never : K
type ExcludeNameField<A> = { [K in ExcludeNameKey<keyof A>]: A[K] }
type ExtractNameParameters<A, T> = A extends { name: T }
  ? ExcludeNameField<A>
  : never
// duplicated from below, bring these all together!
type ExcludeTypeFieldScreen<A> = { [K in ExcludeNameKey<keyof A>]: A[K] }
// type ExtractEventParameters<A, T> = A extends { event: T }
//   ? {} extends Omit<A, 'event'>
//     ? never
//     : Omit<A, 'event'>
//   : never

type ExcludeTypeField<A> = { [K in ExcludeEventKey<keyof A>]: A[K] }

type ExtractSimpleEvent<A> = A extends any
  ? {} extends ExcludeTypeField<A>
    ? A
    : never
  : never

type ExtractComplexEvent<A> = A extends any
  ? {} extends ExcludeTypeField<A>
    ? never
    : A
  : never

// duplicated code, change later
type ExtractSimpleScreen<A> = A extends any
  ? {} extends ExcludeTypeFieldScreen<A>
    ? A
    : never
  : never

type ExtractComplexScreen<A> = A extends any
  ? {} extends ExcludeTypeFieldScreen<A>
    ? never
    : A
  : never
// ok, onto the meat now
type EventOptions =
  | 'View Screen'
  | 'Send SMS'
  | 'Create Account'
  | 'Verify SMS Code'
  | 'Sign Out'
  | 'Create Booking'
  | 'Press Book Artist'

type EventCreator<E extends EventOptions> = { event: E }

// export type ViewScreen = EventCreator<'View Screen'> & {
//   name: ScreenName
// }

// type Screens = ViewScreen

// auth events
type SendSMS = EventCreator<'Send SMS'> & {
  phone_number: string
}
type CreateAccount = EventCreator<'Create Account'> & {
  user: AllUserAccountTypes
}
type SignOut = EventCreator<'Sign Out'>
type CreateBooking = EventCreator<'Create Booking'> & {
  slug: string
}

type VerifySMS = EventCreator<'Verify SMS Code'>

type PressBookArtist = EventCreator<'Press Book Artist'> & {
  slug: string
}

// join all the events together
type Events =
  | SendSMS
  | CreateAccount
  | VerifySMS
  | SignOut
  | CreateBooking
  | PressBookArtist

// if we have an empty object, meaning there are no parameters to pass,
// then we don't even request this field
type SimpleEventType = ExtractSimpleEvent<Events>['event']
type ComplexEventType = ExtractComplexEvent<Events>['event']

export type SimpleScreenType = ExtractSimpleScreen<Screens>['name']
type ComplexScreenType = ExtractComplexScreen<Screens>['name']

async function track<E extends SimpleEventType>(event: E): Promise<void>
async function track<E extends ComplexEventType>(
  event: E,
  properties: ExtractEventParameters<Events, E>
): Promise<void>
async function track<E extends SimpleEventType | ComplexEventType>(
  event: E,
  properties?: ExtractEventParameters<Events, E>
) {
  if (properties) {
    return AnalyticsBase.trackWithProperties(event, properties)
  }
  return AnalyticsBase.track(event)
}

// event to track a screen view
export type ScreenName =
  | 'Discover'
  | 'Artist'
  | 'Bookings'
  | 'Search'
  | 'Bookings'
  | 'Likes'
  | 'My Account'
  | 'Discover (Fast)'
  | 'Create Booking'

type ViewScreenCreator<N extends ScreenName> = { name: N }

type ViewScreenDiscover = ViewScreenCreator<'Discover'>
type ViewScreenSearch = ViewScreenCreator<'Search'>
type ViewScreenDiscoverFast = ViewScreenCreator<'Discover (Fast)'>
type ViewScreenArtist = ViewScreenCreator<'Artist'> & Pick<Artist, 'slug'>
type ViewScreenCreateBooking = ViewScreenCreator<'Create Booking'> &
  Pick<Artist, 'slug'>
type ViewScreenMyAccount = ViewScreenCreator<'My Account'>
type ViewScreenBookings = ViewScreenCreator<'Bookings'>

type Screens =
  | ViewScreenDiscover
  | ViewScreenDiscoverFast
  | ViewScreenArtist
  | ViewScreenCreateBooking
  | ViewScreenMyAccount
  | ViewScreenBookings
  | ViewScreenSearch

async function screen<N extends SimpleScreenType>(name: N): Promise<void>
async function screen<N extends ComplexScreenType>(
  name: N,
  properties: ExtractNameParameters<Screens, N>
): Promise<void>
async function screen<N extends SimpleScreenType | ComplexScreenType>(
  name: N,
  properties?: ExtractNameParameters<Screens, N>
) {
  if (properties) {
    return AnalyticsBase.screenWithProperties(name, properties)
  }
  return AnalyticsBase.screen(name)
}

const Analytics = {
  track,
  screen,
  identify: AnalyticsBase.identify,
  reset: AnalyticsBase.reset,
}

export default Analytics
